import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
import { FormContext } from '../context/FormContext';
import loadFormData from './data/formDataLoader';
import validation from '../validation';
import ACTIONS from './actions';
/**
 * @returns {{state: import('./types').EcrionFormState}}
 */

var useFormAPI = function useFormAPI() {
  var _React$useContext = React.useContext(FormContext),
      _React$useContext2 = _slicedToArray(_React$useContext, 2),
      state = _React$useContext2[0],
      dispatch = _React$useContext2[1];

  var loadData = function loadData(form) {
    return loadFormData(state, form, dispatch);
  };

  var validate = function validate() {
    return validation.validateForm(state, dispatch);
  };

  var setPristine = function setPristine() {
    return dispatch({
      type: ACTIONS.SET_FORM_DIRTY,
      payload: false
    });
  };

  return {
    state: state,
    dispatch: dispatch,
    loadData: loadData,
    validate: validate,
    setPristine: setPristine
  };
};

export default useFormAPI;